// The platform essentials (D81): always allowed whatever list a group uses, read-only.
import { ShieldCheck } from "@phosphor-icons/react";
import { useQuery } from "@tanstack/react-query";

import { useT } from "../i18n";
import { WidgetCard } from "../ui/Card";
import { ErrorState, Loading } from "../ui/states";
import { Mono } from "../ui/status";
import { essentialsQuery } from "./api";

export function EssentialsCard({ className }: { className?: string }) {
  const t = useT().network.essentials;
  const essentials = useQuery(essentialsQuery());
  return (
    <WidgetCard className={className} title={t.title} description={t.hint} action={<ShieldCheck weight="duotone" className="h-5 w-5 text-secondary" aria-hidden />}>
      {essentials.isPending ? <Loading /> : null}
      {essentials.isError ? <ErrorState title={t.loadFailed} message={essentials.error.message} /> : null}
      {essentials.data ? (
        <ul className="m-0 flex list-none flex-wrap gap-1.5 p-0" aria-label={t.title}>
          {essentials.data.map((d) => (
            <li key={d}>
              <Mono className="rounded-md bg-gray-100 px-2 py-0.5 text-[12px]">{d}</Mono>
            </li>
          ))}
        </ul>
      ) : null}
    </WidgetCard>
  );
}
